module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aE2GX"))).then(() => parcelRequire('1iHdE'));